<div class="fdk-dialog-content">
  <ng-content></ng-content>
</div>
